/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { RouteConfig } from 'vue-router';
import { AUTH_STATE } from '@/config';

export default [
  {
    name: 'pay',
    path: '/pay',
    meta: { tabbar: 'secret/user', auth: AUTH_STATE.LOGGED_IN },
    components: {
      static: () => import('@/views/common/static'),
      header: () => import('@/views/common/header'),
      main: () => import('@/views/common/main'),
      footer: () => import('@/views/common/footer'),
    },
    redirect: { name: 'pay_donate' },
    children: [
      {
        name: 'pay_donate',
        path: 'donate',
        meta: { auth: AUTH_STATE.LOGGED_IN, title: '获取积分' },
        component: () => import('@/views/pay/donate.vue'),
      },
    ],
  },
] as RouteConfig[];
